<div class="container">
    <h1>Not Found</h1>
    <button class="btn btn-info btn-lg" routerLink="/">Return to home page</button>
</div>